import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import { router } from './router';
import { queryClient } from './lib/queryClient';
import { ThemeProvider } from './lib/theme';
import { SearchProvider } from './lib/search';
import './styles/global.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root missing');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <SearchProvider>
          <RouterProvider router={router} />
        </SearchProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
